module.exports = __webpack_public_path__ + "img/inx.9f680afc.png";